class RLM_AnimatedBlocks {
    constructor (wrapper, isSubpage = false) {
        this.isSubpage = isSubpage;
        this.mainWrapper = jQuery(wrapper);
        this.isMobile = false;
        this.scriptInitialized = false;
        this.mobileViewport = window.matchMedia('screen and (max-width: 768px)');
        this.desktopViewport = window.matchMedia('screen and (min-width: 769px)');

        if (!this.mainWrapper.find('.animated-block-outer').length) {
            return;
        }
        
        if (this.mobileViewport.matches) {
            this.isMobile = true;
        }

        if (this.isMobile) {
            jQuery(document.body).addClass('no-animated-blocks');
        } else {
            this.scriptInitialized = true;
            this.initState();        
            this.initEvents();
        }

        jQuery(window).on('load', () => {
            this.initVideos();
        });

        this.mobileViewport.addListener(mq => {
            if (mq.matches) {
                this.isMobile = true;
                jQuery(document.body).addClass('no-animated-blocks');

                setTimeout(() => {
                    this.mobileCleanUp();
                }, 500);
            }
        });

        this.desktopViewport.addListener(mq => {
            if (mq.matches) {
                this.isMobile = false;
                jQuery(document.body).removeClass('no-animated-blocks');

                if (!this.scriptInitialized) {
                    this.scriptInitialized = true;
                    this.initState();        
                    this.initEvents();
                }
            }
        });
    }

    // Initial state
    initState () {
        this.win = jQuery(window);
        this.body = jQuery(document.body);
        this.bordersTriggerArea = Math.min(240, parseInt((this.win.outerHeight() / 900) * 240, 10));
        this.currentBlock = -1;
        this.blocks = this.mainWrapper.find('.animated-block-outer');
        this.blockPositions = [];
        this.blockBordersProgress = [];
        this.contentProgress = [];
        this.blockBorders = this.getBlockBorders();
        this.windowHeight = this.win.innerHeight();
    }

    // Add events
    initEvents () {
        this.bindedResize = this.recalculate.bind(this);
        this.bindedScroll = this.scroll.bind(this);
        this.win.on('resize', this.bindedResize);
        this.win.on('scroll', this.bindedScroll);
        this.mainWrapper.find('.animated-block-content').css('opacity', 0);
        this.win.trigger('resize');
        this.win.trigger('scroll');

        this.win.on('load', () => {
            this.win.trigger('resize');
            this.win.trigger('scroll');
        });
    }

    // Init videos
    initVideos () {
        let videoBlocks = this.mainWrapper.find('.animated-block-outer[data-video-bg="1"]');

        if (!videoBlocks.length) {
            return;
        }

        for (let i = 0; i < videoBlocks.length; i++) {
            let videoPath = '';

            if ($(window).outerWidth() > 1040) {
                videoPath = videoBlocks.eq(i).attr('data-video-bg-high');
            } else {
                videoPath = videoBlocks.eq(i).attr('data-video-bg-low');
            }

            let videoElement = $('<video src="' + videoPath + '" muted autoplay playsinline loop class="animated-block-video-cover is-hidden"></video>');
            let coverElement = videoBlocks.eq(i).find('.animated-block-cover');
            videoElement.appendTo(coverElement.eq(0).parent());

            videoElement.on('loadeddata', () => {
                videoElement.removeClass('is-hidden');
                videoElement[0].play();
            });
        }
    }

    // Creates object with border elements
    getBlockBorders () {
        let output = [];

        for (let i = 0; i < this.blocks.length; i++) {
            let block = this.blocks.eq(i);
            let borders = {
                left: block.find('.animated-block-border-left'),
                top: block.find('.animated-block-border-top'),
                right: block.find('.animated-block-border-right'),
                bottom: block.find('.animated-block-border-bottom'),
                overlay: block.find('.animated-block-border-overlay'),
                content: block.find('.animated-block-content'),
                disabledDarkEffect: block.attr('data-without-dark-bg') === '1'
            };
            
            output.push(borders);
        }

        return output;
    }

    // Recalculate positions on window resize
    recalculate () {
        this.windowHeight = this.win.innerHeight();
        this.bordersTriggerArea = Math.min(360, parseInt((this.win.outerHeight() / 900) * 360, 10));
        this.blockPositions = [];

        for (let i = 0; i < this.blocks.length; i++) {
            let block = this.blocks.eq(i);
            let content = block.find('.animated-block-content');

            this.blockPositions.push([
                block.offset().top, // start
                block.offset().top + block.outerHeight(), // end
                block.outerHeight() // height
            ]);

            if (content.length) {
                content = content.eq(0)
                let contentHeight = content.height();

                if (contentHeight < (this.windowHeight - 64)) {
                    let paddingBottom = ((this.windowHeight - 64) - contentHeight) / 2;
                    content.css('padding-bottom', paddingBottom + 'px');
                } else {
                    content.css('padding-bottom', '150px');
                }

                content.css('padding-top', (((this.windowHeight * 0.5) + 32) - (contentHeight / 2)) + 'px');
                content.css('margin-top', (-1 * (this.windowHeight * 0.4)) + 'px');
            }
        }
    }

    // Mobile clean up
    mobileCleanUp () {
        for (let i = 0; i < this.blocks.length; i++) {
            let block = this.blocks.eq(i);
            let content = block.find('.animated-block-content');

            if (content.length) {
                content = content.eq(0);
                content.attr('style', '');
            }
        }
    }

    // Scroll event
    scroll (e) {
        if (
            !this.isSubpage && this.body.hasClass('is-subpage-open') ||
            this.isSubpage && !this.body.hasClass('is-subpage-open') ||
            this.isMobile
        ) {
            return;
        }

        let currentScroll = this.win.scrollTop();
        let previousBlock = this.currentBlock;
        this.currentBlock = this.getCurrentBlock(currentScroll);

        // Reset block borders if necessary
        if (previousBlock !== this.currentBlock) {
            if (previousBlock !== -1) {
                this.animateBorders(1, 1, previousBlock);
            }
        }

        // Animate borders if necessary
        if (this.currentBlock > -1) {
            let bordersProgress = this.getBordersProgress(currentScroll, this.currentBlock);
            let contentProgress = this.getContentProgress(currentScroll, this.currentBlock);
            this.animateBorders(bordersProgress, contentProgress, this.currentBlock);
        }
    }

    // Returns a number of current block based on scroll
    getCurrentBlock (currentScroll) {
        let currentBlock = -1;

        for (let i = 0; i < this.blockPositions.length; i++) {
            if (currentScroll >= this.blockPositions[i][0] && currentScroll <= this.blockPositions[i][1]) {
                currentBlock = i;
            }
        }

        return currentBlock;
    }

    // Returns a progress of scroll inside the block
    getScrollProgress (currentScroll, blockNumber) {
        let relativeOffset = currentScroll - this.blockPositions[blockNumber][0];
        let progress = (relativeOffset / this.blockPositions[blockNumber][2]) * 100;

        if (progress < 0) {
            progress = 0;
        }

        if (progress > 100) {
            progress = 100;
        }

        return progress;
    }

    // Returns borders progress
    getBordersProgress (currentScroll, blockNumber) {
        let relativeOffset = currentScroll - this.blockPositions[blockNumber][0];

        if (relativeOffset <= this.bordersTriggerArea) {
            let progress = 1 - (relativeOffset / this.bordersTriggerArea);

            if (progress < 0) {
                progress = 0;
            }

            return progress;
        }

        return 0;
    }

    // Returns content progress
    getContentProgress (currentScroll, blockNumber) {
        let relativeOffset = (currentScroll - this.blockPositions[blockNumber][0]);
        let contentHeight = this.blockBorders[blockNumber].content.height();
        let contentScrollOffset = this.blockBorders[blockNumber].content.offset().top - currentScroll;

        if (relativeOffset < 0) {
            return 1;
        }

        if (relativeOffset <= contentHeight + this.windowHeight && contentScrollOffset > 0) {
            let progress = 1 - (2 - ((contentScrollOffset / (relativeOffset + contentScrollOffset)) + 1));

            if (progress < 0) {
                progress = 0;
            }

            return progress;
        }

        return 0;
    }

    // Animate borders based on progress
    animateBorders (progress, contentProgress, blockNumber) {
        if (!this.blockBorders[blockNumber]) {
            return;
        }

        if (this.blockBordersProgress[blockNumber] !== progress ) {
            this.blockBordersProgress[blockNumber] = progress;
            this.blockBorders[blockNumber].left.css('transform', 'scale(' + progress + ', 1)');
            this.blockBorders[blockNumber].top.css('transform', 'scale(1, ' + progress + ')');
            this.blockBorders[blockNumber].right.css('transform', 'scale(' + progress + ', 1)');
            this.blockBorders[blockNumber].bottom.css('transform', 'scale(1, ' + progress + ')');

            if (!this.blockBorders[blockNumber].disabledDarkEffect) {
                this.blockBorders[blockNumber].overlay.css('opacity', 1 - progress);    
            }
        }

        if (this.contentProgress[blockNumber] !== contentProgress) {
            this.blockBorders[blockNumber].content.css('opacity', 1 - contentProgress);
        }
    }

    refresh () {
        this.win.trigger('resize');
        this.win.trigger('scroll');
    }

    clear () {
        $(window).off('resize', this.bindedResize);
        $(window).off('scroll', this.bindedScroll);
    }

    addEvents () {
        this.bindedResize = this.recalculate.bind(this);
        this.bindedScroll = this.scroll.bind(this);
        this.win.on('resize', this.bindedResize);
        this.win.on('scroll', this.bindedScroll);
        this.win.trigger('resize');
        this.win.trigger('scroll');
    }
}

window.VMAnimatedBlocksInstance = new RLM_AnimatedBlocks(document.body, false);